import React from "react";
import Image from "react-image";
import { connect } from "react-redux";

export const LogoComponent = ({ theme, dispatch, ...props }) => {
  const background = theme["logo"];
  console.log(theme);
  return background ? <Image src={background} {...props} /> : null;
};

const mapStateToProps = state => ({
  theme: { ...state.theme }
});

export const LogoComponentConnected = connect(mapStateToProps)(LogoComponent);
